import React, { useContext, useState, memo } from 'react';
import MaterialTable from 'material-table';
import Edit from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Context } from 'src/context/Contex';
import { minPermisos } from 'src/constants/permits';
import { useStyles, tableIcons } from './styles';

const defaultRows = 10;
const defaultIndex = -1;

const PolygonsTable = (props) => {
  const {
    onDeleteTable,
    dataTable = [],
    idPermisoTabla,
    columns,
    onClickEdit,
    titleTable,
    hiddenEdit,
    loading,
    selectCheckbox = false,
    exportButton = true,
    hiddenDelete,
    actionsColumn = defaultIndex,
    rows = defaultRows,
    handleSelect,
    hiddenActions = true,
  } = props;
  const classes = useStyles();
  const [selectedRow, setSelectedRow] = useState(null);
  const { permisos } = useContext(Context);
  const minValue = permisos[idPermisoTabla];

  let data = [];
  let stateEdit = false;
  let stateDelete = false;

  if (minValue >= minPermisos.ACTUALIZAR === false && hiddenEdit === false) {
    stateEdit = true;
  }

  if (minValue >= minPermisos.ELIMINAR === false && hiddenDelete === false) {
    stateDelete = true;
  }

  if (dataTable) {
    data = dataTable;
  }

  return (
    <div className={classes.root}>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          localization={{
            pagination: {
              labelDisplayedRows: '{from}-{to} of {count}',
            },
            toolbar: {
              nRowsSelected: '{0} row(s) selected',
            },
            header: {
              actions: 'Acción',
            },
            body: {
              emptyDataSourceMessage: 'No hay elementos en la tabla',
              filterRow: {
                filterTooltip: 'Filter',
              },
            },
          }}
          //icons={tableIcons}
          title={titleTable}
          columns={columns}
          data={data}
          isLoading={loading}
          onRowClick={(evt, rowData) => setSelectedRow(rowData.tableData.id)}
          onSelectionChange={(rowData, selectedRow) => handleSelect(selectedRow)}
          options={{
            pageSize: rows,
            loadingType: 'linear',
            actionsColumnIndex: actionsColumn,
            draggable: false,
            filtering: false,
            padding: 'dense',
            exportButton,
            exportAllData: true,
            exportFileName: 'Exportación Lucia Analitics',
            search: true,
            selection: selectCheckbox,
            showTextRowsSelected: false,
            showSelectAllCheckbox: false,
            headerStyle: {
              backgroundColor: '#1B1B1B',
              color: '#FFF',
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? '#EEE' : '#FFF',
              wordWrap: 'break-word',
              fontSize: 14,
            }),
          }}
          actions={
            hiddenActions
              ? [
                {
                  icon: () => (
                    <Edit
                      className={classes.tableActionButtonIcon}
                      style={{ color: ' #4CAF50' }}
                    />
                  ),
                  tooltip: 'status',
                  onClick: (event, rowData) => onClickEdit({ event, rowData }),
                  hidden: stateEdit || hiddenEdit,
                },
                {
                  icon: () => (
                    <DeleteIcon
                      className={classes.tableActionButtonIcon}
                      style={{ color: '#f44336 ' }}
                    />
                  ),
                  tooltip: 'status',
                  onClick: (event, rowData) => onDeleteTable({ event, rowData }),
                  hidden: stateDelete || hiddenDelete,
                },
              ]
              : null
          }
        />
      </div>
    </div>
  );
};

export default memo(PolygonsTable);
